// src/components/RecipeSlider.tsx
import React, { useState, useEffect } from 'react';
import './RecipeSlider.scss';
import logo_cesar from './../assets/receipe-1.jpg'
import logo_spaghetti from './../assets/spag-1.jpg'
import logo_lasagna from './../assets/Lasagna.jpg'
import logo_fruits from './../assets/fruits.jpg'

const recipeImages = [
    logo_cesar,
    logo_spaghetti,
    logo_lasagna,
    logo_fruits,
    logo_cesar,
    logo_spaghetti,
    logo_cesar,
    logo_spaghetti,
    logo_cesar,
    logo_spaghetti,
];

const RecipeSlider: React.FC = () => {
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentImageIndex((prevIndex) => (prevIndex + 1) % recipeImages.length);
        }, 4000);

        return () => clearInterval(interval);
    }, []);

    return (
        <div className="recipe-slider">
            <img src={recipeImages[currentImageIndex]} alt="Recipe" className="recipe-image" />
        </div>
    );
};

export default RecipeSlider;
